const formSubmission = require('../lib/formSubmission');

window.addEventListener('load', function() {

    const permissionsForm = document.getElementById('frm-permissions');
    if (permissionsForm) {
        const inputElements = permissionsForm.getElementsByTagName('input');
        for (let i = 0; i < inputElements.length; i++) {
            const inputElement = inputElements[i];
            if (inputElement.type === 'radio') {
                inputElement.addEventListener('click', sendPermission);
            }
        }
    }

    const stateForm = document.getElementById('frm-state');
    if (stateForm) {
        const inputElements = stateForm.getElementsByTagName('input');
        for (let i = 0; i < inputElements.length; i++) {
            const inputElement = inputElements[i];
            if (inputElement.type === 'radio') {
                inputElement.addEventListener('click', sendState);
            }
        }
    }

});

function sendPermission(radioButton) {

    const form = document.getElementById('frm-permissions');

    const permissionName = radioButton.target.name;
    const outcome = radioButton.target.value;

    const formData = new FormData();
    formData.append('granted', outcome);

    const url = form.getAttribute('action') + '/' + permissionName;
    const submissionControl = radioButton;
    const notificationControl = form.getElementsByClassName('notification')[0];
    const success = function () {
        location.reload(true);
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

function sendState(radioButton) {

    const form = document.getElementById('frm-state');

    const state = radioButton.target.value;

    const formData = new FormData();
    formData.append('state', state);

    const url = form.getAttribute('action');
    const submissionControl = radioButton;
    const notificationControl = form.getElementsByClassName('notification')[0];
    const success = function () {
        location.reload(true);
        return null;
    };

    formSubmission.submitFormData(formData, url, submissionControl, notificationControl, success);

}

